var map = {
	"./2C.png": 3916,
	"./2D.png": 6731,
	"./2H.png": 4016,
	"./2S.png": 9663,
	"./3C.png": 5570,
	"./3D.png": 4017,
	"./3H.png": 5073,
	"./3S.png": 5088,
	"./4C.png": 2317,
	"./4D.png": 5302,
	"./4H.png": 1246,
	"./4S.png": 8687,
	"./5C.png": 8934,
	"./5D.png": 5679,
	"./5H.png": 9168,
	"./5S.png": 6504,
	"./6C.png": 843,
	"./6D.png": 6977,
	"./6H.png": 4932,
	"./6S.png": 2494,
	"./7C.png": 699,
	"./7D.png": 3384,
	"./7H.png": 8550,
	"./7S.png": 6048,
	"./8C.png": 6856,
	"./8D.png": 4948,
	"./8H.png": 2883,
	"./8S.png": 3974,
	"./9C.png": 2901,
	"./9D.png": 2833,
	"./9H.png": 7736,
	"./9S.png": 693,
	"./AC.png": 7147,
	"./AD.png": 7070,
	"./AH.png": 3130,
	"./AS.png": 8303,
	"./BACK.png": 1899,
	"./BLUE_BACK.png": 4542,
	"./HIDDENHIDDEN.png": 1072,
	"./JC.png": 7712,
	"./JD.png": 4548,
	"./JH.png": 4370,
	"./JS.png": 9703,
	"./KC.png": 6354,
	"./KD.png": 5094,
	"./KH.png": 7123,
	"./KS.png": 6954,
	"./QC.png": 6810,
	"./QD.png": 8880,
	"./QH.png": 2569,
	"./QS.png": 9611,
	"./TC.png": 5380,
	"./TD.png": 5714,
	"./TH.png": 5258,
	"./TS.png": 1791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1099;